import React, { Suspense } from "react";
import { UserPostulationsPage } from "@rankmi/ats-app";
import { SelectionProcessStatusService } from '../../../src/core/services/selection_process_status_service'
import { EnterpriseAreaService } from '../../../src/core/services/enterprise_area_service'
import { SelectionProcessesService } from '../../../src/core/services/selection_processes_service'

const UserPostulations = ({ statusActive, showAreaFilter }) => {
  const selectionProcessService = new SelectionProcessesService();
  const enterPriseAreaService = new EnterpriseAreaService();
  const statusService = new SelectionProcessStatusService();

  return (
    <Suspense fallback="">
      <UserPostulationsPage
        statusActive={statusActive} 
        selectionProcessService={selectionProcessService}
        enterPriseAreaService={enterPriseAreaService}
        statusService={statusService}
        showAreaFilter={showAreaFilter}
      />
    </Suspense>
  );
};

export default UserPostulations;
